import React from 'react';
import RaisedButton from 'material-ui/RaisedButton';
import '../style.scss';

export default class Button extends React.Component {
  static contextTypes = {
    muiTheme: React.PropTypes.object.isRequired,
  }

  constructor(props) {
    super(props)

    this.backgroundColor = this.backgroundColor.bind(this)
    this.labelColor = this.labelColor.bind(this)
    this.borderColor = this.borderColor.bind(this)
  }

  backgroundColor() {
    return this.context.muiTheme.button.backgroundColor[this.props.buttonType];
  }

  labelColor() {
    return this.context.muiTheme.button.labelColor[this.props.buttonType];
  }

  borderColor() {
    if (this.props.disabled) { return 'transparent'; }

    return this.context.muiTheme.button.borderColor[this.props.buttonType];
  }

  fontSize() {
    const { buttonType } = this.props
    switch (buttonType) {
      case 'cta':
        return 14;
      default:
        return 12;
    }
  }

  render() {
    return(
      <RaisedButton {...this.props}
        backgroundColor={this.backgroundColor()}
        buttonStyle={{borderRadius: 6, border: `solid 1px ${this.borderColor()}`}}
        labelColor={this.labelColor()}
        labelStyle={{fontFamily: 'Montserrat,sans-serif', letterSpacing: 0.3, fontWeight: 400, fontSize: this.fontSize()}}
        style={{borderRadius: 6, backgroundColor: 'transparent', minWidth: 0}}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./app/components/Button.js